<template>
  <div class="">
     <!-- 查询表单 -->
     <div>
      <el-form ref="newAttrForm" :model="newAttrForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="渠道名称">
                <el-input v-model="newAttrForm.openName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
                <el-input v-model="newAttrForm.thirdCategoryName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="换机侠属性名称">
                <el-input v-model="newAttrForm.hjxAttrName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getAttrNameMappingList">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="openAppName"
            label="渠道名称">
          </el-table-column>
          <el-table-column
            prop="thirdCategoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="thirdOptionName"
            label="第三方选项名称">
          </el-table-column>
          <el-table-column
            prop="thirdAttrName"
            label="第三方选项值名称">
          </el-table-column>
          <el-table-column
            prop="hjxAttrCode"
            label="换机侠属性编码">
          </el-table-column>
          <el-table-column
            prop="hjxAttrName"
            label="换机侠属性名称">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                 <el-button @click="deleteAttrNameMapping(scope.row)" type="text" size="small">删除</el-button> 
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '绑定属性' : ''" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editNewAttrForm" :model="editNewAttrForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID">
              <el-input clearable v-model="editNewAttrForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="第三方平台名称">
              <el-input clearable v-model="editNewAttrForm.thirdOpenName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="第三方分类">
              <el-input clearable v-model="editNewAttrForm.thirdCategoryName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="第三方品牌">
              <el-input clearable v-model="editNewAttrForm.thirdBrandName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="第三方选项名称">
              <el-input clearable v-model="editNewAttrForm.thirdOptionName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="第三方选项值名称">
              <el-input clearable v-model="editNewAttrForm.thirdAttrName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="评估分类">
              <el-radio-group v-model="valuationClass" @change="valuationClassChange()" v-removeAriaHidden>
                <el-radio   :label="1">物品信息</el-radio>
                <el-radio   :label="25">成色信息</el-radio>
                <el-radio   :label="26">功能信息</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="评估选项" v-if="valuationClass!=1">
              <el-select
                v-model="editNewAttrForm.optionId"
                placeholder="请选择"
                filterable
                @change="changeValuetionOption()"
              >
                <el-option
                  v-for="item in valuationOptionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评估选项" v-if="valuationClass==1">
              <el-select
                v-model="editNewAttrForm.LinkageTypeId"
                placeholder="请选择"
                filterable
                @change="changeLinkageType()"
              >
                <el-option
                  v-for="item in LinkageTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选项值">
              <el-select
                v-model="editNewAttrForm.hjxAttrId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in selectOptionValueList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      newAttrForm: {
        openName: null
      },
      valuationClass:1,
      
       // 评估分类
       LinkageTypeList: [
        {"id":19,"name":"内存选项管理"},
        {"id":20,"name":"购买渠道选项管理"},
        {"id":21,"name":"机身颜色选项管理"},
        {"id":22,"name":"保修时长选项管理"},
        {"id":23,"name":"小型号选项管理"},
        {"id":24,"name":"网络制式选项管理"},
        {"id":28,"name":"处理器选项管理"},
        {"id":29,"name":"显卡选项管理"},
        {"id":30,"name":"固态硬盘选项管理"},
        {"id":31,"name":"机械硬盘选项管理"},
        {"id":36,"name":"充电接口选项"},
        {"id":37,"name":"充电方式选项"},
        {"id":38,"name":"表壳尺寸选项"},
        {"id":39,"name":"表壳材质选项"},
        {"id":40,"name":"表带选项"},
        {"id":41,"name":"表带颜色选项"},
        {"id":42,"name":"左右耳选项"},
        {"id":43,"name":"外置键盘选项"},
        {"id":44,"name":"配件情况"},
      ],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tempGradeIdList:null,

      // 新建编辑对话框数据

      isDlg: false,
      editNewAttrForm: {
        id: null,
        categoryName:null,
        brandName:null,
        modeId:null,
        modelName:null,
        hjxCategoryId:null,
        hjxBrandId:null,
        hjxModelId:null
      },
      dlgType: 'change',
      queryGradeList:[],
        // 选择
      modelOptions: [],
      loading: false,
      updateFlag:false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      skuInfo:{},
      selectOptionValueList:[],
      valuationOptionList:[],
      editorFormRules: {
        hjxAttrId: [
          { required: true, message: '请选择选项值', trigger: 'change' },
        ]
      },
    }
  },
  watch:{},
  computed:{},
  methods:{
    deleteAttrNameMapping(row){
      let self = this
      self.$api.deleteAttrNameMapping(row.id).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getAttrNameMappingList()
              }
            })
    },
    changeValuetionOption(){
      let self=this
      this.getSelectFuncationAndConditionOptionValueList(this.editNewAttrForm.optionId)
      self.$set(self.editNewAttrForm, "hjxAttrId", null);
    },
    changeLinkageType(){
      let self=this
      this.getSelectOptionValueList(this.editNewAttrForm.thirdCategoryId,this.editNewAttrForm.thirdBrandId,this.editNewAttrForm.LinkageTypeId)
      self.$set(self.editNewAttrForm, "hjxAttrId", null);
    },
    valuationClassChange(){
      let self=this
      if(this.valuationClass!=1){
        this.getValuationOptionList(this.editNewAttrForm.thirdCategoryId,this.valuationClass)
        self.$set(self.editNewAttrForm, "LinkageTypeId", null);
      }else{
        this.$set(self.editNewAttrForm, "optionId", null);
      }
      this.$set(self.editNewAttrForm, "hjxAttrId", null);
      this.updateFlag =false;
      this.nextTick(()=>{
        self.updateFlag =true;
      })
    },
    //获取品牌下的sku信息
    skuTree(val) {
      let self = this;
      self.$api
        .skuTree({
          brandId: val,
        })
        .then((res) => {
          self.skuInfo = res.data;
        });
    },
    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    // 请求分类列表，提供编辑时选择用
    getValuationOptionList(categoryId,LinkageTypeId) {
      let self = this;
      self.$api
        .getValuationOptionList({
          categoryId: categoryId,
          linkageTypeId: LinkageTypeId
        })
        .then((res) => {
          if (res.code === 200) {
            self.valuationOptionList = res.data;
          }
        });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectFuncationAndConditionOptionValueList(optionId) {
      let self = this;
      self.$api
        .getSelectFuncationAndConditionOptionValueList({
          optionId: optionId
        })
        .then((res) => {
          if (res.code === 200) {
            self.selectOptionValueList = res.data;
          }
        });
    },
     // 请求分类列表，提供编辑时选择用
     getSelectOptionValueList(categoryId, brandId,LinkageTypeId) {
      let self = this;
      self.$api
        .getSelectOptionValueList({
          categoryId: categoryId,
          brandId: brandId,
          LinkageTypeId: LinkageTypeId
        })
        .then((res) => {
          if (res.code === 200) {
            self.selectOptionValueList = res.data;
          }
        });
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getAttrNameMappingList()
    }, 

    // 获取门店列表
    getAttrNameMappingList() {
      let self  = this;
      self.$api.listSearchAttrNameMapping({
        page: self.currentPage,
        size: self.pageSize,
        openName: self.newAttrForm.openName || null,
        thirdCategoryName: self.newAttrForm.thirdCategoryName || null,
        hjxAttrName: self.newAttrForm.hjxAttrName || null,
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 修改门店
    editorBindNewAttrMapping(row) {
      let self = this;
      self.editNewAttrForm=JSON.parse(JSON.stringify(row));
      self.dlgType = 'change'
      self.valuationClass=1
      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editNewAttrForm'].validate((valid) => {
        if (valid) {

          if(self.dlgType === 'change') {
            self.$api.bindNewAttrMapping({newAttrMappingId:self.editNewAttrForm.id,hjxAttrId:self.editNewAttrForm.hjxAttrId}).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getAttrNameMappingList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getAttrNameMappingList();
    // self.getSelectOptions("category", "categoryOptions");
  }
}
</script>
<style lang="less" scoped>
 
    /deep/ .el-radio__original {
      display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
    }
    
    /deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
        box-shadow: none !important;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>